export default __webpack_public_path__ + "static/d4cc2493-a895-4aee-8384-9f12698e2bb6-4bba008f53a0e39d4f192b489f7ea073.woff2";